import addToCart from '../utils/_addToCart';

class mProductTile extends HTMLDivElement {
    constructor() {
        super();
        this.dyEnabled = Object.hasOwnProperty.call(this.dataset, 'dyEnabled');
        this.personnalizedVariation = document.querySelector('.js-dyEngagement')?.dataset.personnalizedVariation;
        this.image = this.querySelector('[is="m-tile-images"');
        this.imageSlider = this.querySelector('[is="m-tile-slider"] a');
        this.quickBuy = this.querySelector('.quick-buy-btn');
        this.oosButton = this.querySelector('.btn-unavailability');
        this.sendEngagement = this.sendEngagement.bind(this);
        this.onClick = this.onClick.bind(this);
        this.sendGtmEventOnClick = this.sendGtmEventOnClick.bind(this);
        this.sendGtmEventQuickBuy = this.sendGtmEventQuickBuy.bind(this);
        this.saveReturnToProductId = this.saveReturnToProductId.bind(this);
    }

    connectedCallback() {
        if (this.dyEnabled) {
            this.manageDynamicYield();
        }
        if (this.image) {
            this.image.addEventListener('click', this.sendGtmEventOnClick);
        }
        if (this.imageSlider) {
            this.imageSlider.addEventListener('click', this.sendGtmEventOnClick);
        }
        if (this.quickBuy) {
            this.quickBuy.addEventListener('click', this.sendGtmEventQuickBuy);
        }
        this.setCta();
        this.addEventListener('click', this.saveReturnToProductId);
    }

    sendGtmEvent(e, eventName) {
        const gtmData = this.querySelector('[data-gtm]');
        // To avoid putting index in cache in Tile-Show
        // Find index on input sibling element for GTM
        let el = this;

        while (el) {
            el = el.previousSibling;
            if (el && el.dataset && el.dataset.index) {
                break;
            }
        }
        const parseGtmData = JSON.parse(gtmData.dataset.gtm);
        parseGtmData.ecommerce.items[0].index = el?.dataset ? parseInt(el.dataset.index, 10) : 0;

        if (gtmData) {
            document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
                detail: {
                    data: parseGtmData,
                    eventName,
                    pageType: true,
                    getListInfo: true,
                    target: e.target,
                },
            }));
        }
    }

    sendGtmEventOnClick(e) {
        e.preventDefault();
        this.sendGtmEvent(e, 'select_item');
        if (this.image || this.imageSlider) {
            window.location.href = this.image ? this.image.href : this.imageSlider.href;
        }
    }

    sendGtmEventQuickBuy(e) {
        this.sendGtmEvent(e, 'select_quick_view');
    }

    /**
     * Manage dynamic yield engagement report when user interact with the tile (redirect to product or add to cart)
     */
    manageDynamicYield() {
        const recommendationItem = this.closest('.recommendation-item');
        const recommendationSlider = this.closest('[is="m-reco-slider"');
        if (recommendationItem) {
            this.decisionId = recommendationItem.dataset.decisionId;
            this.slotId = recommendationItem.dataset.slotId;
        } else if ('tileReordering' in this.dataset) {
            this.slotId = this.dataset.slotId;
            this.decisionId = this.dataset.decisionId;
        }

        if (recommendationSlider) {
            this.engagementUrl = recommendationSlider.dataset.engagementUrl;
        } else if (this.parentElement && 'engagementUrl' in this.parentElement.dataset) {
            this.engagementUrl = this.parentElement.dataset.engagementUrl;
        }
        if (this.image && !this.image.dataset.eventAttached) {
            this.image.addEventListener('click', () => {
                this.sendEngagement(true);
            });
            this.image.dataset.eventAttached = true;
        }
        if (this.quickBuy) {
            this.quickBuy.addEventListener('click', () => {
                this.sendEngagement(false);
            });
        }
        this.addEventListener('click', this.onClick);
    }

    /**
     * Triggered when user click in the product tile (add conditions to target certain parts of the tile)
     * @param {Event} e event
     */
    onClick(e) {
        const addToCartButton = e.target.closest('.add-to-cart');
        if (addToCartButton && !addToCartButton.disabled && !addToCartButton.classList.contains('add-to-cart-disabled')) {
            addToCart(addToCartButton, 'Recommendations');
            this.sendEngagement(false);
        }
    }

    /**
     * Send engagement report to server
     * @param isImage
     */
    sendEngagement(isImage) {
        if (this.engagementUrl && (this.decisionId || this.slotId)) {
            let body = {};

            if (this.slotId && isImage) {
                body = {
                    slotId: this.slotId,
                };
            } else {
                body = {
                    decisionId: this.decisionId,
                };
            }

            fetch(this.engagementUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            });
        }
    }

    setCta() {
        const stockState = this.querySelector('[name="stockstate"]');
        if (stockState && stockState.dataset.type === 'oos' && this.quickBuy && this.oosButton) {
            this.quickBuy.remove();
            this.oosButton.classList.remove('d-none');
            this.oosButton.ariaLabel = stockState.value;
        } else if (stockState && this.quickBuy && this.oosButton) {
            this.quickBuy.remove();
            this.oosButton.remove();
        } else if (this.quickBuy && this.oosButton) {
            this.quickBuy.classList.remove('d-none');
            this.oosButton.remove();
        }
    }

    saveReturnToProductId() {
        const pid = this.getAttribute('data-pid');
        if (pid) {
            sessionStorage.setItem('returnToPid', pid);
            sessionStorage.setItem('returnToPidPLP', window.location.pathname);
        }
    }
}

customElements.define('m-product-tile', mProductTile, {
    extends: 'div',
});
